<template>
  <dv-decoration-5 class="decoration-container" :color="color" :dur="dur"></dv-decoration-5>
</template>
<script>
import { decoration5 } from '@jiaminghi/data-view'
import Vue from 'vue'
import Minin from './mixin'
Vue.use(decoration5)
export default {
  name: 'Decoration5',
  mixins: [Minin]
}
</script>
<style lang="less" scoped>
  .decoration-container{
    width: 100%;
    height: 100%;
  }
</style>